import React, { useCallback } from 'react'
import SelectField, { SelectProps } from './select'
import { TextFieldProps } from '@material-ui/core/TextField'
import { t } from 'i18n'
import withTableWrapper from './withTableWrapper'
import withInlineWrapper from './withInlineWrapper'

interface TranslatedSelectProps {
  name: string
  label?: string
  required?: boolean
  options: string[]
  translationScope?: string
  getOptionLabel?: SelectProps<string>['AutocompleteProps']['getOptionLabel']
  AutocompleteProps?: Omit<SelectProps<string>['AutocompleteProps'], 'getOptionLabel' | 'options'>
  TextFieldProps?: Omit<TextFieldProps, 'label' | 'required'>
}

const getTextValue = (
  item: string,
  { getOptionLabel, translationScope }: Pick<TranslatedSelectProps, 'getOptionLabel' | 'translationScope'>
) => {
  if (!item && getOptionLabel) {
    return getOptionLabel(item)
  }
  return (getOptionLabel ? getOptionLabel(item) : t(item, { scope: translationScope, defaultValue: item })) || ''
}

export const TranslatedSelectField: React.FC<TranslatedSelectProps> = ({
  name,
  label,
  options,
  required = false,
  translationScope,
  getOptionLabel,
  AutocompleteProps,
  TextFieldProps
}) => {
  const fLabel = useCallback((item: string) => getTextValue(item, { getOptionLabel, translationScope }), [getOptionLabel, translationScope])

  return (
    <SelectField
      name={name}
      AutocompleteProps={{
        getOptionLabel: fLabel,
        options,
        getOptionSelected: undefined,
        ...AutocompleteProps
      }}
      TextFieldProps={{
        label: label,
        required: required,
        ...TextFieldProps
      }}
    />
  )
}

export const TranslatedInlineSelectField = withInlineWrapper(TranslatedSelectField, getTextValue, {
  isSelect: true,
  autoFocus: false
})
export const TranslatedInlineSelectFieldWithShadow = withInlineWrapper(TranslatedSelectField, getTextValue, {
  isSelect: true,
  autoFocus: false,
  showShadow: true
})
export const TableTranslatedInlineSelectField = withTableWrapper(TranslatedInlineSelectField)
